module.exports = __webpack_public_path__ + "static/cf-reg-italic-223714506da181adf23c05248171174f.woff";